import _ from 'lodash'
import type { IBlocksAppsUtils, ViewerAppSpecData } from '@wix/thunderbolt-symbols'
import type { BootstrapData } from '../../types'
import { BLOCKS_APPS_UTILS, BOOTSTRAP_DATA } from './moduleNames'

export const BlocksAppsUtils = (bootstrapData: BootstrapData): IBlocksAppsUtils => {
	const {
		wixCodeBootstrapData: { wixCodePageIds, codePackagesData, wixCodeModel },
		platformEnvData,
		blocksBootstrapData,
		appsSpecData,
	} = bootstrapData

	const identityTokenAppSpecData = Object.values(appsSpecData).find((spec) => spec.isIdentityTokenAppSpec)

	return {
		createBlocksPreviewAppData() {
			return {
				blocksPreviewData: {
					gridAppId: _.get(wixCodeModel, 'appData.codeAppId'),
					metaSiteId: platformEnvData.location.metaSiteId,
					widgetsCodeMap: _.mapValues(wixCodePageIds, (url) => ({ url })),
					widgetDescriptorsMap: platformEnvData.blocks?.blocksPreviewData?.widgetDescriptorsMap ?? {},
				},
			}
		},
		createBlocksConsumerAppData(appSpecData: ViewerAppSpecData) {
			return {
				blocksConsumerData: {
					experiments: blocksBootstrapData.experiments,
					codeExperimentsQueryString: blocksBootstrapData.experimentsQueryParams,
					codePackagesData,
					invokePropsChangedOnUpdateConfig: true,
					widgetBundleUrls: blocksBootstrapData.widgetBundleUrls?.[appSpecData.appDefinitionId],
					isVeloBundlerParastorageUrlEnabled: blocksBootstrapData.isVeloBundlerParastorageUrlEnabled,
					parastorageTemplateUrl: blocksBootstrapData.parastorageTemplateUrl,
				},
			}
		},
		isBlocksApp(appDefinitionId) {
			return Boolean(blocksBootstrapData.blocksAppsData[appDefinitionId])
		},
		isElevatedBlocksAppOnReactNative(appDefinitionId) {
			return Boolean(blocksBootstrapData.elevatedBlocksAppsOnReactNative?.includes(appDefinitionId))
		},
		canAppInstanceBeUsedForAuthorization(appInstance?: string): boolean {
			if (!appInstance) {
				return false
			}

			return appInstance.startsWith('OauthNG')
		},
		isFixWixDataInstanceForBlocksPreviewExperimentOpen(): boolean {
			return Boolean(platformEnvData.site.experiments['specs.thunderbolt.FixWixDataInstanceForBlocksPreview'])
		},
		getBlocksOriginalAppDefinitionId() {
			const isUseOriginalBlocksAppInstanceExperimentOpen =
				platformEnvData.site.experiments['specs.thunderbolt.UseOriginalBlocksAppInstance']
			if (!identityTokenAppSpecData || !isUseOriginalBlocksAppInstanceExperimentOpen) {
				return undefined
			}
			const originalAppDefinitionId = identityTokenAppSpecData.appDefinitionId
			const isBlocksApp = this.isBlocksApp(originalAppDefinitionId)
			if (isBlocksApp) {
				return originalAppDefinitionId
			}
		},
	}
}

export default {
	factory: BlocksAppsUtils,
	deps: [BOOTSTRAP_DATA],
	name: BLOCKS_APPS_UTILS,
}
